import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DesktopContainer,
  LoadingSpinner,
} from '@rabbit/elements/shared-components';
import PersonalInfoContainer from '../../../templates/Account/PersonalInfoContainer';
import { useMyConsumerPersona } from '@rabbit/data/portal';

function PersonalInfoView() {
  const consumerPersona = useMyConsumerPersona();
  const consumerPersonaId = consumerPersona?.personaId;
  const consumerPersonaData = consumerPersona?.data.consumer_private;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  if (
    consumerPersonaData === null ||
    !consumerPersonaData ||
    !consumerPersonaId
  )
    return <LoadingSpinner size="md" isFullScreen />;

  return (
    <DesktopContainer
      title="Personal information"
      goBack={() => navigate(-1)}
      loading={isLoading}
    >
      <PersonalInfoContainer
        id={consumerPersonaId}
        data={consumerPersonaData}
        setIsLoading={setIsLoading}
      />
    </DesktopContainer>
  );
}

export default PersonalInfoView;
